import { store } from '../../common/redux/configure-store';
import { getEwicUtilizationReceipt } from './services/get-ewic-utilization-receipt';
import { getEwicBalanceInquiryReceipt } from './services/get-ewic-balance-inquiry-receipt';
import { printReceipts } from 'src/devices/printer-operations';
import { IReceipt } from 'src/common/interfaces/dtos/IReceipt';
import { WICTenderData } from 'src/items-list/business-logic/service/interfaces/cart-response';
import { EwicReceiptType } from '../enumerations/ewic-receipt-type';
import { EwicPrintDTO } from '../interfaces/ewic-print.dto';
import { showEftInfo } from './show-eft-info';
import { popupMessage } from 'src/messages/business-logic/popup-message';

export const handleEwicReceipts = async (
  amountTendered: number,
  wicTenderData?: WICTenderData,
): Promise<void> => {
  if (wicTenderData === undefined) {
    return;
  }
  await getEwicBalanceInquiryReceipt(buildEwicPrintInitialBalanceDTO(wicTenderData))
    .then((receipts: IReceipt[]) => printReceipts(receipts))
    .catch(popupMessage);

  if (wicTenderData.utilization && wicTenderData.utilization?.length > 0) {
    await getEwicUtilizationReceipt(
      buildEwicPrintUtilizationDTO(wicTenderData, amountTendered),
    ).then(async (receipts: IReceipt[]) => {
      await printReceipts(receipts).catch(popupMessage);
      return showEftInfo(
        'EwicUtilizationCustomerAttRequiredTitle',
        'EwicUtilizationCustomerAttRequiredMessage',
        'Continue',
        'Cancel',
      );
    });
  }
};

const buildEwicPrintUtilizationDTO = (
  tenderResponse: WICTenderData,
  utilizedAmountTotal?: number,
): Partial<EwicPrintDTO> => {
  const printUtilizationDTO = {
    ...getEwicPrintDTO(tenderResponse),
    utilizedDollarAmountTotal: utilizedAmountTotal,
    utilization: tenderResponse?.utilization || [],
  };
  return printUtilizationDTO;
};

const buildEwicPrintInitialBalanceDTO = (wicTender: WICTenderData): Partial<EwicPrintDTO> => {
  const printInitialBalanceDTO = {
    ...getEwicPrintDTO(wicTender),
    receiptType: EwicReceiptType.INITIALBALANCE,
  };
  return printInitialBalanceDTO;
};

const getEwicPrintDTO = (wicTender: WICTenderData): Partial<EwicPrintDTO> => {
  const cardInfo = {
    ...wicTender.cardInfo,
    expirationDate: wicTender.cardInfo?.experationDate,
  };
  delete cardInfo['experationDate'];
  return {
    cardInfo: cardInfo,
    inquiryReferenceId: '', // Leaving this blank for now till we know where this value comes from.
    utcDateTime: new Date().toUTCString(),
    cashierName: store.getState().user.displayName,
    cashierUsername: store.getState().user.userName,
    itemPrescriptions: wicTender?.initialItemPrescriptions,
  };
};
